import React from 'react';
import { connect } from 'react-redux';
import { openOverlay } from './OverlayActions';

// Reuse the existing login and contract-type dialogs. Opening this button does
// not create an agreement or request a blockchain transaction. While logged
// out, the login dialog is asked to open the contract chooser after sign-in.
function NewAgreementButton({ auth, dispatch }) {
  function startAgreement() {
    if (auth.status === 'loggedin') {
      dispatch(openOverlay('new_contract', { user: auth.username }));
    } else {
      dispatch(openOverlay('login', { next: 'new_contract' }));
    }
  }

  return (
    <button type="button" className="agreementPrimaryButton" onClick={startAgreement}>
      Create an agreement
    </button>
  );
}

export default connect(state => ({ auth: state.auth }))(NewAgreementButton);
